import { type FC } from 'react';
import CheckIcon from '@assets/img/icons/check-2.svg?react';
import { cva, type VariantProps } from 'class-variance-authority';

import css from './styles.module.scss';

const overlayVariant = cva('', {
  variants: {
    checkSize: {
      default: css.checkDefault,
      small: css.checkSmall,
    },
  },
});

const CompleteOverlay: FC<VariantProps<typeof overlayVariant>> = ({
  checkSize = 'default',
}) => {
  return (
    <div className={css.completeOverlay}>
      <div className={overlayVariant({ checkSize })}>
        <CheckIcon />
      </div>
    </div>
  );
};

export { CompleteOverlay };
